module.exports = __webpack_public_path__ + "static/media/become-img-1.fc13be62.png";